module.exports = __webpack_public_path__ + "static/assets/61770332e78f162cae91044d4ea84ca2.gif";